import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CardListDetails from "./CardListDetails";
import CancelIcon from "@material-ui/icons/Cancel";
import Loader3Orange from "../../general/Loader3Orange";
import {
  addPaymentCard,
  allPaymentCard,
  getAllCardsInformation,
  deletePaymentCard,
  deleteCardSuccess,
  defaultPaymentCard,
  defaultCardSuccess,
  getDefaultCardInitialized,
  getDefaultCardFailed,
  getGettingPaymentSuccess,
} from "../../store/myquotes";

const CardList = (props) => {
  const dispatch = useDispatch();
  const [card, setCard] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const cardListing = useSelector(getAllCardsInformation);
  const paymentDetails = useSelector(getGettingPaymentSuccess);
  const cardDetails = useSelector(deleteCardSuccess);
  const defaultCard = useSelector(defaultCardSuccess);
  const defaultInialized = useSelector(getDefaultCardInitialized);
  const defaultInializedFailed = useSelector(getDefaultCardFailed);
  const [selectedValue, setSelectedValue] = useState(0);
  useEffect(() => {
    dispatch(allPaymentCard());
  }, [dispatch]);

  useEffect(() => {
    if (cardListing) {
      setCard(cardListing);
    }
  });
  useEffect(() => {
    if (defaultCard) {
      setCard(card);
    }
  });

  const cardDelete = (cId, index) => {
    setIsLoading(true);
    dispatch(deletePaymentCard({ cardId: cId })).then(() => {
      setIsLoading(false);
    });
    const list = [...card];
    list.splice(index, 1);
    setCard((...card) => [...list]);
    if (cardDetails) {
      toast.success(cardDetails.message);
    }
  };

  const handleChecked = (id, i) => {
    setIsLoading(true);
    setSelectedValue(i);
    dispatch(defaultPaymentCard({ cardId: id })).then(() => {
      if (defaultCard) {
        setIsLoading(false);
      }
    });

    if (defaultCard) {
      const currentData = card[i];
      let checkList = [...card];
      checkList.splice(i, 1);
      checkList.splice(0, 0, currentData);
      setCard((...card) => [...checkList]);
      setSelectedValue(0);
      toast.success(defaultCard.message);
    }
  };
  return (
    <>
      <div className="container">
        <div className="row">
          {!cardListing || isLoading ? (
            <div
              style={{
                width: "100%",
              }}
            >
              <Loader3Orange></Loader3Orange>
            </div>
          ) : null}

          {card &&
            card.map((items, i) => {
              return (
                <React.Fragment key={items.id}>
                  <div className="col-sm-4">
                    <div style={{ position: "absolute", top: 0, right: 0 }}>
                      <CancelIcon
                        fontSize="large"
                        style={{ cursor: "pointer", color: "#818182" }}
                        onClick={() => {
                          cardDelete(items.id, i);
                        }}
                      ></CancelIcon>
                    </div>
                    <CardListDetails items={items} id={i} />
                    <div className="form-check ml-3">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id={items.id}
                        value={i}
                        checked={selectedValue === i}
                        onChange={() => {
                          handleChecked(items.id, i);
                        }}
                      />
                      <label
                        style={{
                          fontSize: "100%",
                          fontFamily: "GibsonRegular",
                        }}
                        className="form-check-label"
                        htmlFor={items.id}
                      >
                        Default Card
                      </label>
                    </div>
                  </div>
                </React.Fragment>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default CardList;
